import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

// V1's MuteModal content in the pitch inbox's modal language (same flow, same copy)
function PitchMuteModal({
  show, onHide, durationDays, onDurationChange, defaultMuteDurationDays, onSubmit,
}) {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered contentClassName="pitch-inbox">
      <Modal.Header closeButton>
        <Modal.Title className="paragraph-lg">
          <i className="fa-solid fa-volume-xmark me-2" />
          Mute User
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="alert alert-warning small mb-3">
          Are you sure you want to mute this user?
          <br />
          Automatically hide new pitches from this user. They&apos;ll still be able to reply within any existing
          conversations.
        </div>
        <div className="d-flex gap-4">
          <label className="form-check d-flex align-items-center gap-2" htmlFor="pi-mute-default">
            <input
              className="form-check-input mt-0"
              id="pi-mute-default"
              type="radio"
              value={defaultMuteDurationDays}
              checked={durationDays === `${defaultMuteDurationDays}`}
              onChange={onDurationChange}
            />
            Mute for {defaultMuteDurationDays} days
          </label>
          <label className="form-check d-flex align-items-center gap-2" htmlFor="pi-mute-permanent">
            <input
              className="form-check-input mt-0"
              id="pi-mute-permanent"
              type="radio"
              value="0"
              checked={durationDays === '0'}
              onChange={onDurationChange}
            />
            Mute Permanently
          </label>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-top-0 pt-0">
        <button type="button" className="btn btn-danger" onClick={onSubmit}>
          Mute User
        </button>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

PitchMuteModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  durationDays: PropTypes.string.isRequired,
  onDurationChange: PropTypes.func.isRequired,
  defaultMuteDurationDays: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default PitchMuteModal;
